import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import cx from "classnames";
import Accordion from "react-bootstrap/Accordion";

import styles from "./styles.module.scss";
import userRoleService from "src/utils/userRoles.service";

interface CoachingSideMenuProps {
  expanded: boolean;
}

interface MenuItem {
  name: string;
  url?: string;
  icon?: string;
  visible?: () => boolean;
  action?: () => void;
}

const CoachingSideMenu: React.FC<CoachingSideMenuProps> = ({ expanded }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState<any>("");

  const canCreate = userRoleService.canCreateCourse();
  const canAccessCallLibrary = userRoleService.canAccessCallLibrary();

  const handleBack = () => {
    const back = userRoleService.getHomePagePath();
    navigate(back);
  };

  const handleClick = (item: MenuItem) => {
    if (item.action) { 
      return item.action()
    }

    if (item.url) { 
      return navigate(item.url)
    }
  };

  const menuConfig: MenuItem[] = [
    { name: "explore", url: "/coaching/explore", icon: "paperflite-explore" },
    { name: "microlearning", url: "/coaching/microlearning", icon: "paperflite-bulb" },
    { name: "my space", url: "/coaching/courses", icon: "paperflite-my-space" },
    { name: "studio", url: "/coaching/studio", icon: "paperflite-studio", visible: () => canCreate },
    {
      name: "manage",
      url: "/coaching/manage",
      icon: "paperflite-account",
      visible: () => canCreate 
    },
    {
      name: "call library",
      url: "/coaching/meetings",
      icon: "paperflite-call-calendar",
      visible: () => canAccessCallLibrary
    },
    {
      name: "reports",
      url: "/coaching/reports",
      icon: "paperflite-paperflite-reports",
    },
  ];

  return (
    <aside className={styles.menu}>
      <div className={styles.back} onClick={handleBack}>
        <div className={styles.item}>
          <i className={cx("paperflite-arrow-up", styles.arrow)} />
          <span className={cx(styles.label, { [styles.expanded]: expanded })}>
            back
          </span>
        </div>
      </div>

      <div className={styles.divider} />

      <Accordion
        activeKey={activeKey}
        onSelect={(key) => setActiveKey(key)}
        className={styles.settings}
        alwaysOpen
      >
        {menuConfig
          .filter((item) => (item.visible ? item.visible() : true))
          .map((item, index) => (
            <Accordion.Item eventKey={index.toString()} key={index}>
              <Accordion.Header
                onClick={() => handleClick(item)}
                className={cx({[styles.active]: item.url && location.pathname.includes(item.url)})}>
                <div className={styles.item}>
                  <i className={cx(item.icon, styles.icon)} />

                  <span className={cx(styles.label, {[styles.expanded]: expanded})}>
                    {item?.name}
                  </span>
                </div>
              </Accordion.Header>
            </Accordion.Item>
          ))}
      </Accordion>
    </aside>
  );
};

export default CoachingSideMenu;
